import { EmailOpenHeartOutlineIcon } from './EmailOpenHeartOutlineIcon';

/**
 * author: Jeff Anders
 * id BA4C3DC0-3F05-4464-BA25-CB5AA0E96789
 * name email-open-heart-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-open-heart-outline.svg
 * tags
 */
export const GreetingCardOpenIcon = EmailOpenHeartOutlineIcon;
export default GreetingCardOpenIcon